export const range = (begin: number, end: number) => [...Array(end - begin)].map((_, i) => i)
